import { createQueryFn } from '@oneview/redux/utils';
import { api } from './baseApi';

export const insightsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getOptionRadar: build.query({
            queryFn: createQueryFn((_: void, { extra: api }) => {
                return api.orbisMiddleware.research.getOptionRadar();
            }),
        }),
        getStockScreenerIndustryCodes: build.query({
            queryFn: createQueryFn(async (_: void, { extra: api }) => {
                const response = await api.orbisSdk.client.request(
                    'GET',
                    '/research/industries/list',
                    '',
                    '',
                    'json',
                    {},
                    null,
                );
                return response.data;
            }),
        }),
        // getStockScreener: build.query({
        //     queryFn: createQueryFn(
        //         async (screenerArr: ScreenerApiCallObject[], { extra: api }) => {
        //             const response = await api.orbis.post('research/screener', screenerArr);
        //             return response.data;
        //         },
        //         {
        //             pendingMessage: 'Screening…',
        //         },
        //     ),
        // }),
        // getStockScreenerV2: build.query({
        //     queryFn: createQueryFn(
        //         async (values: StockScreenerBlockValues, { extra: api }) => {
        //             const body = cloneDeep(values.screenerCall);
        //             body.queries.forEach((query) => {
        //                 // If comparator is Between for number values(not dates), need to split the query into 2, one greater than, one less than.
        //                 if (
        //                     query.comparator === StockScreenerComparators.Between &&
        //                     query.field !== StockScreenerFieldValues.DividendExDate &&
        //                     query.field !== StockScreenerFieldValues.DividendPayDate
        //                 ) {
        //                     body.queries.push({
        //                         field: query.field,
        //                         comparator: StockScreenerComparators.LessThan,
        //                         value: Array.isArray(query.value) ? query.value[1]! : query.value,
        //                         dateRange: query.dateRange,
        //                     });

        //                     query.comparator = StockScreenerComparators.GreaterThan;
        //                     query.value = Array.isArray(query.value) ? query.value[0]! : query.value;

        //                     //TODO:For Dates we need to change between to equals comparator, this will probably change with new endpoint
        //                 } else if (
        //                     (query.comparator === StockScreenerComparators.Between &&
        //                         query.field === StockScreenerFieldValues.DividendExDate) ||
        //                     query.field === StockScreenerFieldValues.DividendPayDate
        //                 ) {
        //                     query.comparator = StockScreenerComparators.Equals;
        //                 }
        //             });

        //             const response = await api.orbis.client.request(
        //                 'POST',
        //                 '/research/screener/v2',
        //                 '',
        //                 body,
        //                 'json',
        //                 {},
        //                 null,
        //             );
        //             return response.data;
        //         },
        //         {
        //             pendingMessage: 'Screening…',
        //         },
        //     ),
        // }),
        getAnalystProfile: build.query({
            queryFn: createQueryFn((expertUid: string, { extra: api }) => {
                return api.orbisMiddleware.tipranks.getTipranksAnalystProfile(expertUid);
            }),
        }),
        getAnalystPortfolio: build.query({
            queryFn: createQueryFn(({ expertUid, count }: { expertUid: string; count?: number }, { extra: api }) => {
                return api.orbisMiddleware.tipranks.getTipranksAnalystPortfolio(expertUid, count);
            }),
        }),
    }),
});

export const {
    useGetOptionRadarQuery,
    useGetAnalystProfileQuery,
    useGetAnalystPortfolioQuery,
    useGetStockScreenerIndustryCodesQuery,
    useLazyGetStockScreenerIndustryCodesQuery,
} = insightsApi;
